var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("div", { staticClass: "section-listGame__header paddingTOP40" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title__text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("front.search.titles.results")))]),
            _c("p", [_vm._v(_vm._s(_vm.$t("front.search.titles.results")))])
          ])
        ])
      ]),
      _c("catalog-bar-with-provider-filter", {
        attrs: {
          "sort-options": _vm.sortOptions,
          "vendor-platform-ids": _vm.vendorPlatformIds
        },
        on: {
          sortOptionChanged: _vm.sortGames,
          platformFilterChanged: _vm.filterGames
        }
      }),
      _c(
        "div",
        [
          _vm._l(_vm.cycleComponents, function(component, index) {
            return _c(component, {
              key: index,
              tag: "component",
              attrs: { items: _vm.getComponentItems(index) }
            })
          }),
          _vm.hasMoreGames
            ? _c(
                "div",
                {
                  staticClass: "btn-loadCatalog",
                  on: { click: _vm.showMoreGames }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("front.search.button.load_more")))
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      ),
      !_vm.loading && !_vm.sortedCategoryGames.length
        ? _c("div", { staticClass: "text-center mt-5 mb-4" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("front.game.info.no_one_game_found")))
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }